import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Define types
export interface BreadcrumbItem {
  title: string;
  path: string;
  icon?: string;
}

export interface BreadcrumbState {
  items: BreadcrumbItem[];
}

// Initial state
const initialState: BreadcrumbState = {
  items: []
};

// Create the slice
const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    setBreadcrumbs: (state, action: PayloadAction<BreadcrumbItem[]>) => {
      state.items = action.payload;
    },
    addBreadcrumb: (state, action: PayloadAction<BreadcrumbItem>) => {
      state.items.push(action.payload);
    },
    clearBreadcrumbs: (state) => {
      state.items = [];
    }
  }
});

// Selectors
export const getBreadcrumbs = (state: { breadcrumb: BreadcrumbState }) => state.breadcrumb.items;

// Export actions and reducer
export const { setBreadcrumbs, addBreadcrumb, clearBreadcrumbs } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
